import { render, staticRenderFns } from "./ApplicationCertificateRule.vue?vue&type=template&id=4967bae4&scoped=true"
import script from "./ApplicationCertificateRule.vue?vue&type=script&lang=js"
export * from "./ApplicationCertificateRule.vue?vue&type=script&lang=js"
import style0 from "./ApplicationCertificateRule.vue?vue&type=style&index=0&id=4967bae4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4967bae4",
  null
  
)

export default component.exports